import React, { useState, useEffect } from "react";
import { createQuickBoost, updateQuickBoost } from "./adminQuickBoostService";

const QuickBoostForm = ({ data, onSaved, onCancel }) => {
 const isEdit = !!data;

 const [form, setForm] = useState({
 title: "",
 description: "",
 youtubeLink: "",
 });

 const [loading, setLoading] = useState(false);

 useEffect(() => {
 if (data) {
 setForm({
 title: data.title || "",
 description: data.description || "",
 youtubeLink: data.youtubeLink || "",
 });
 }
 }, [data]);

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSubmit = async () => {
 if (!form.title || !form.description) {
 alert("Title and Description are required");
 return;
 }

 const payload = {
 title: form.title,
 description: form.description,
 ...(form.youtubeLink && { youtubeLink: form.youtubeLink }),
 };

 setLoading(true);
 const res = isEdit
 ? await updateQuickBoost(data.id, payload)
 : await createQuickBoost(payload);

 if (res.status === 200 || res.status === 201) {
 onSaved();
 } else {
 alert(res.message || "Operation failed");
 }
 setLoading(false);
 };

 return (
 <div className="modal-overlay">
 <div className="modal-content">
 <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
 <h2>{isEdit ? "Edit" : "Create"} Quick Boost</h2>

 <div className="form-group">
 <label>Title *</label>
 <input
 name="title"
 placeholder="e.g. How to Introduce Yourself in English"
 value={form.title}
 onChange={handleChange}
 />
 </div>

 <div className="form-group">
 <label>Description *</label>
 <textarea
 name="description"
 placeholder="Brief description of the quick boost..."
 value={form.description}
 onChange={handleChange}
 rows={3}
 />
 </div>

 <div className="form-group">
 <label>YouTube Link (optional)</label>
 <input
 name="youtubeLink"
 placeholder="https://youtube.com/watch?v=..."
 value={form.youtubeLink}
 onChange={handleChange}
 />
 </div>

 <div className="form-actions">
 <button onClick={handleSubmit} disabled={loading}>
 {loading ? "Saving..." : isEdit ? "Update" : "Create"}
 </button>
 <button onClick={onCancel} disabled={loading}>
 Cancel
 </button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default QuickBoostForm;
